import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/GetApp";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import httpClient from "common/api/httpClient";
import ConfirmationModal from "common/components/ConfirmationModal";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { getResourcesStoreInfo } from "store/resourcesStore/resourcesStoreSlice";
import { Resource, deleteResource, getResources } from "../store";

const CRUDTable = () => {
  const dispatch = useAppDispatch();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
  const [resource, setResource] = useState<Resource>({
    name: "",
  });
  const [resourceName, setResourceName] = useState<string>("");

  useEffect(() => {
    dispatch(getResources());
  }, [dispatch]);

  const { list } = useAppSelector((state) => {
    return state.developer.resourcesCRUD;
  });

  const { loading, resourcesStoreInfo } = useAppSelector((state) => {
    return state.resourcesStore;
  });

  useEffect(() => {
    if (!loading && resourcesStoreInfo && resourceName) {
      const link = document.createElement("a");
      link.href = `${httpClient.getUri()}Resources/ResourcesStore/Download/${resourceName}?sharedFormToken=${
        resourcesStoreInfo.sharedFormToken
      }`;
      link.click();
      setResourceName("");
    }
  }, [loading, resourceName, resourcesStoreInfo]);

  const onDownloadResource = (resource: Resource) => {
    setResourceName(resource.name);
    dispatch(getResourcesStoreInfo());
  };

  const onDeleteResource = (resource: Resource) => {
    setIsDeleteModalOpen(true);
    setResource(resource);
  };

  const cancelDeleteForm = () => {
    setIsDeleteModalOpen(false);
  };

  const confirmDeleteForm = () => {
    setIsDeleteModalOpen(false);
    dispatch(deleteResource(resource.name));
  };

  return (
    <>
      <ConfirmationModal
        open={isDeleteModalOpen}
        onConfirm={confirmDeleteForm}
        onCancel={cancelDeleteForm}
        title="Confirm deletion?"
        confirmLabel="Yes, delete"
        cancelLabel="Cancel"
        mainButtonType="primary"
        defaultAction="cancel"
      >
        You are about to delete {resource.name} resource.
      </ConfirmationModal>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {list.map((resource, index) => (
            <TableRow key={index}>
              <TableCell component="td" scope="row">
                {resource.name}
              </TableCell>
              <TableCell align="right">
                <IconButton
                  aria-label="download"
                  onClick={() => onDownloadResource(resource)}
                  size="large"
                >
                  <DownloadIcon />
                </IconButton>
                <IconButton
                  aria-label="delete"
                  onClick={() => onDeleteResource(resource)}
                  size="large"
                >
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
};

export default CRUDTable;
